// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3mGsS","item":"PaymentsMobile_item__n-j72","label":"PaymentsMobile_label__fCEz5","amount":"PaymentsMobile_amount__7dZLr"};